define('drops/documentIntelligencePreviewer/documentIntelligencePreviewer',[
    'jquery',
    'underscore',
    'lq',
    'lq/drop',
    'lq/frontendModules',
], function ($, _, lq, Drop, FrontendModules) {
    'use strict';

    var DocumentIntelligencePreviewer = function (options) {
        Drop.call(this, $('<div>'), options);
    };

    Drop.extend(DocumentIntelligencePreviewer, Drop);

    DocumentIntelligencePreviewer.typeName = 'DocumentIntelligencePreviewer';

    DocumentIntelligencePreviewer.prototype.preRender = function () {
        var self = this;

        this.DocumentPreviewerComponent = null;

        this.piping.visibility.apply(this);
        this.applyPosition();

        FrontendModules.load('documentIntelligenceViewer', true)
            .then(self.showComponent.bind(self));

        this.piping.datasources.registerDatasourceListener(
            this.data.documentsDatasource,
            function (data) {
                self.documentDataSourceResult = data;

                if (self.DocumentPreviewerComponent)
                    self.setData(data, self.boundingRegionsDataSourceResult);
            }
        );

        this.piping.datasources.registerDatasourceListener(
            this.data.boundingRegionsDatasource,
            function (data) {
                self.boundingRegionsDataSourceResult = data;

                if (self.DocumentPreviewerComponent && self.documentDataSourceResult)
                    self.setData(self.documentDataSourceResult, data);
            }
        );
    };

    DocumentIntelligencePreviewer.prototype.showComponent = function (DocumentViewerRendered) {
        this.DocumentPreviewerComponent = DocumentViewerRendered;

        if (this.documentDataSourceResult)
            this.setData(this.documentDataSourceResult, this.boundingRegionsDataSourceResult);
    };


    DocumentIntelligencePreviewer.prototype.setData = function (documentDataSourceResult, boundingRegionsDataSourceResult) {
        var self = this;
        var documentUrl = documentDataSourceResult.results[0][this.data.documentsDataColumn].Url;
        var fileName = documentDataSourceResult.results[0][this.data.documentsDataColumn].Filename;
        var url = this.getFullDocumentUrl(documentUrl);

        var boundingRegions = [];

        if (boundingRegionsDataSourceResult)
            _.map(boundingRegionsDataSourceResult.results, function(result) {
                var boundingJson = JSON.parse(result[self.data.boundingRegionsColumn]);
                var boundingRegion = {
                    pageNumber: boundingJson.PageNumber,
                    polygon: boundingJson.Polygon,
                    color: result[self.data.colorColumn],
                    tooltip: result[self.data.tooltipColumn]
                };

                boundingRegions.push(boundingRegion);
            });

        var config = {
            url: url,
            fileName: fileName,
            borderWidth: this.data.borderWidth,
            backgroundOpacity: this.data.backgroundOpacity,
            initialZoom: this.data.initialZoom
        };

        this.DocumentPreviewerComponent.default(boundingRegions, config, this.$element.get(0));
    };

    DocumentIntelligencePreviewer.prototype.getFullDocumentUrl = function (documentUrl) {
        return lq.getFullUrl(lq.getTenantUrl('DynamicContent/DownloadFile?url=' + documentUrl + '&openInBrowser=true'));
    };

    return DocumentIntelligencePreviewer;
});

